var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt20 p20 tc viewpoints" },
    [
      _c("img", {
        staticClass: "mb5 viewpoints-img",
        attrs: {
          src: _vm.userCommonImageUrlForPc + "/viewpoints.png",
          alt: "viewpoints",
          "data-test": "viewpoints-img",
        },
      }),
      _vm._v(" "),
      _c("h3", { staticClass: "fs15 fwB" }, [
        _vm._v("\n    女の転職！取材レポート\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "plr5 mt20" }, [
        _c(
          "div",
          [
            _c(
              "job-preview-right-column",
              _vm._g(
                {
                  attrs: {
                    "text-count-mode": _vm.textCountMode,
                    "highlight-mode": _vm.highlightMode,
                    "comment-class": "report",
                    "comment-highlights": _vm.getAnyCommentHighlights(
                      _vm.targetIdMap.report.staffComment.prefix
                    ),
                    "text-count-class": "report",
                    "text-counts": _vm.textCounts.staff,
                  },
                },
                _vm.$listeners
              )
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }, [
              _vm.report.name
                ? _c("h4", {
                    staticClass: "tl fwB fs14",
                    attrs: {
                      id: _vm.targetIdMap.report.staffComment.name,
                      "data-test": "name",
                    },
                    domProps: {
                      textContent: _vm._s(
                        "取材担当" + _vm.report.name + "より"
                      ),
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("p", {
                staticClass: "tl fs13 pega-pre-wrap",
                attrs: {
                  id: _vm.targetIdMap.report.staffComment.body,
                  "data-test": "body",
                },
                domProps: { textContent: _vm._s(_vm.report.body) },
              }),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _vm.report.improve
          ? _c(
              "div",
              { attrs: { "data-test": "improve" } },
              [
                _c(
                  "job-preview-right-column",
                  _vm._g(
                    {
                      attrs: {
                        "text-count-mode": _vm.textCountMode,
                        "highlight-mode": _vm.highlightMode,
                        "comment-class": "report",
                        "comment-highlights": _vm.getCommentHighlights(
                          _vm.targetIdMap.report.improve
                        ),
                        "text-count-class": "report",
                        "text-counts": [
                          _vm.getTextCount(
                            "この仕事で磨ける経験・能力",
                            _vm.report.improve,
                            _vm.targetIdMap.report.improve
                          ),
                        ],
                      },
                    },
                    _vm.$listeners
                  )
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }, [
                  _c("h4", { staticClass: "tl fwB fs14 mt15" }, [
                    _vm._v("\n          この仕事で磨ける経験・能力\n        "),
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "tl fs13 pega-pre-wrap",
                    attrs: {
                      id: _vm.targetIdMap.report.improve,
                      "data-test": "improve-text",
                    },
                    domProps: { textContent: _vm._s(_vm.report.improve) },
                  }),
                ]),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.interviews.length
        ? [
            _c("h4", { staticClass: "fs14 fwB mt20 tc interview" }, [
              _vm._v("\n      社員の方にインタビューしました\n    "),
            ]),
            _vm._v(" "),
            _vm._l(_vm.interviews, function (interview) {
              return [
                _c(
                  "div",
                  {
                    key: "interview-" + interview.index,
                    staticClass: "clearfix fs13 p20 interview-row",
                    attrs: { "data-test": "interview-" + interview.index },
                  },
                  [
                    _c(
                      "job-preview-right-column",
                      _vm._g(
                        {
                          attrs: {
                            "text-count-mode": _vm.textCountMode,
                            "highlight-mode": _vm.highlightMode,
                            "comment-class": "interview",
                            "comment-highlights": _vm.getAnyCommentHighlights(
                              _vm.targetIdMap.freeTopics.prefix,
                              interview.index
                            ),
                            "text-count-class": "interview",
                            "text-counts": _vm.textCounts.interviews(
                              interview,
                              interview.index
                            ),
                          },
                        },
                        _vm.$listeners
                      )
                    ),
                    _vm._v(" "),
                    _c("dl", { staticClass: "fll tl row-left" }, [
                      interview.title
                        ? _c("dt", {
                            staticClass: "fwB mb5",
                            attrs: {
                              id:
                                _vm.targetIdMap.freeTopics.title +
                                "-" +
                                interview.index,
                              "data-test": "interview-title-" + interview.index,
                            },
                            domProps: { textContent: _vm._s(interview.title) },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("dd", {
                        staticClass: "pega-pre-wrap",
                        attrs: {
                          id:
                            _vm.targetIdMap.freeTopics.body +
                            "-" +
                            interview.index,
                          "data-test": "interview-body-" + interview.index,
                        },
                        domProps: { textContent: _vm._s(interview.body) },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flr" }, [
                      interview.photo
                        ? _c("img", {
                            staticClass: "offer-img-sub",
                            attrs: {
                              id:
                                _vm.targetIdMap.freeTopics.photo +
                                "-" +
                                interview.index,
                              src: _vm.getPhotoUrl(interview.photo),
                              "data-test": "photo-" + interview.index,
                            },
                            on: {
                              load: function ($event) {
                                return _vm.$emit("onLoadImage")
                              },
                              error: function ($event) {
                                return _vm.$emit("onLoadImage")
                              },
                            },
                          })
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ]
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }